/* eslint-disable jsx-a11y/interactive-supports-focus */
import React from 'react'
import { css } from '@emotion/core'

const actionButtonCss = css`
  border-radius: 50%;
  border: unset;
  background: #343434;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.15s;
  &:hover {
    background: white !important;
    color: black !important;
    transform: scale(1.1);
  }
`

const CardActionButton = ({ CardIcon, iconColor, backgroundColor, onClick, ...props }) => {
  return (
    <button
      css={actionButtonCss}
      style={{
        color: iconColor,
        background: backgroundColor,
      }}
      onKeyPress={() => {}}
      onClick={onClick}
      type="button"
      {...props}
    >
      <CardIcon />
    </button>
  )
}

export default CardActionButton
